<template>
  <div class="header">
    <div class="left">
      <img class="logo" @click="goHome" src="../../assets/img/logo.png" alt />
      <div class="tabs">
        <el-tabs v-model="activeName" @tab-click="handleTabClick">
          <el-tab-pane label="首页" name="/home"></el-tab-pane>
          <el-tab-pane label="数据产品" name="/product"></el-tab-pane>
          <el-tab-pane label="研究报告" name="/report"></el-tab-pane>
          <el-tab-pane label="企预测" name="/product?system=4"></el-tab-pane>
          <el-tab-pane label="联系我们" name="/contact"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="right">
      <el-button v-if="!authorization" class="login-btn" @click="goLogin">登录</el-button>
      <div class="user" v-else>
        <span class="go-database" @click="goDatabase">进入数据库</span>
        <el-dropdown trigger="click" :hide-on-click="true" @command="handleCommand">
          <span class="el-dropdown-link">
            <img class="avatar" src="../../assets/img/avatar.png" />
            {{userName()}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="header-dropdown">
            <el-dropdown-item command="editPwd" divided>修改密码</el-dropdown-item>
            <el-dropdown-item command="order" divided>个人订单</el-dropdown-item>
            <el-dropdown-item command="loginout" divided>退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!-- <el-button class="register-btn">注册</el-button> -->
      <el-dialog
        title
        :visible.sync="orderDialog"
        custom-class="order-dialog"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
      >
        <order-list v-if="orderDialog" :isback="false" @showInvoiceDialog="handleShowInvoiceDialog"></order-list>
      </el-dialog>
      <getback-password
        :pwdDialogVisible="pwdDialogVisible"
        @handleClosed="forgetpwdClosed"
        :isback="false"
      ></getback-password>
      <el-dialog
        title
        :visible.sync="invoiceDialog"
        custom-class="invoice-dialog"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
      >
        <invoice
          v-if="invoiceDialog"
          @hideInvoiceDialog="handleHideInvoiceDialog"
          :orderNo="curOrderNo"
          :invoiceFlag="invoiceFlag"
        ></invoice>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import orderList from "@/pages/product/components/orderList.vue";
import invoice from "@/pages/product/components/invoice.vue";
import getbackPassword from "@/pages/login/forgetpwd.vue";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      activeName:
        this.$route.query.id || this.$route.query.flag
          ? this.$route.path
          : this.$route.fullPath,
      orderDialog: false,
      invoiceDialog: false,
      pwdDialogVisible: false, //忘记密码弹框
      curOrderNo: "",
      invoiceFlag: false
    };
  },
  components: {
    orderList,
    invoice,
    getbackPassword
  },
  computed: {
    ...mapState(["userInfo", "authorization"])
  },
  watch: {
    $route() {
      this.activeName =
        this.$route.query.id || this.$route.query.flag
          ? this.$route.path
          : this.$route.fullPath;
    }
  },
  created() {},
  methods: {
    ...mapMutations(["SET_USERINFO", "SET_AUTHORIZATION"]),
    handleTabClick(val) {
      this.$router.push(val.name);
    },
    goLogin() {
      this.$router.push({
        path: "/login",
        query: { redirect: this.$route.fullPath }
      });
    },
    goHome() {
      this.$router.push("/home");
    },
    userName() {
      return this.userInfo.userName;
    },
    handleCommand(command) {
      if (command == "loginout") {
        // 退出登录  清空localstorage相关数据
        localStorage.removeItem("vuex");
        this.SET_USERINFO({});
        this.SET_AUTHORIZATION(null);
      } else if (command == "editPwd") {
        this.pwdDialogVisible = true;
      } else if (command == "order") {
        this.orderDialog = true;
      }
    },
    handleHideInvoiceDialog() {
      this.invoiceDialog = false;
    },
    handleShowInvoiceDialog(obj) {
      this.orderDialog = false
      this.invoiceDialog = true;
      this.curOrderNo = obj.orderNo;
      this.invoiceFlag = obj.invoiceFlag;
    },
    forgetpwdClosed(isclosed) {
      if (isclosed.closed == true) {
        this.pwdDialogVisible = false;
      }
    },
    goDatabase() {
      let url;
      if (process.env.NODE_ENV == "production") {
        url = `http://lightdata.tjresearch.cn/#/macro?userInfo=${JSON.stringify(
          this.userInfo
        )}&auth=${encodeURIComponent(this.authorization)}&moduleId=2`;
      } else {
        url = `http://macro.tj.cn/#/macro?userInfo=${JSON.stringify(
          this.userInfo
        )}&auth=${encodeURIComponent(this.authorization)}&moduleId=2`;
      }
      // console.log(url)
      window.open(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  height: 66px;
  border-bottom: 1px solid #d8d8d8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  .left {
    display: flex;
    .logo {
      height: 24px;
      cursor: pointer;
    }
    /deep/ .el-tabs__header {
      margin: 0;
      margin-left: 84px;
      border-bottom: none;
    }
    /deep/ .el-tabs__item {
      color: #202020;
      border: none;
      font-size: 16px;
    }
    /deep/ .el-tabs__item.is-active {
      color: #dd6643;
      border: none;
    }
    /deep/ .el-tabs__item:hover {
      color: #dd6643;
    }
    /deep/ .el-tabs--card > .el-tabs__header .el-tabs__nav {
      border: none;
    }
    /deep/ .el-tabs__nav-wrap::after {
      display: none;
    }
    /deep/ .el-tabs__active-bar {
      background-color: #dd6643;
      height: 3px;
    }
  }
  .right {
    display: flex;
    .login-btn {
      background-color: #dd6643;
      border-color: #dd6643;
      color: #fff;
      width: 100px;
    }
    .register-btn {
      background-color: #ffffff;
      border-color: #d8d8d8;
      width: 100px;
    }
    .user {
      color: #fff;
      display: flex;
      align-items: center;
      .go-database {
        color: #000;
        padding-right: 20px;
        cursor: pointer;
      }
      .go-database:hover {
        color: #dd6643;
      }
      .el-dropdown-link {
        display: flex;
        cursor: pointer;
        justify-content: center;
        align-items: center;
        font-weight: bold;
      }
      .avatar {
        height: 36px;
        width: 36px;
        padding-right: 8px;
      }
      // 头部下拉框
      .header-dropdown {
        /deep/ .el-dropdown-menu__item {
          color: #fff;
        }
        /deep/ .el-dropdown-menu__item:focus,
        /deep/ .el-dropdown-menu__item:not(.is-disabled):hover {
          background: #373639;
        }
        /deep/ .el-dropdown-menu__item.is-disabled {
          color: #5b5a5a;
        }
      }
      /deep/ .header-dropdown.el-popper[x-placement^="bottom"] {
        background: #201f22;
      }
    }
  }
  /deep/ .el-dialog__body {
    padding: 0 20px;
  }
}
</style>